import { ICON_BASE_PATH } from "@/app/utils/config";
import "./AuthMatrix.scss";
import { useTranslation } from "react-i18next";

interface AddThresholdBtnProps {
  disable: boolean;
  onClick?: () => void;
}

export const AddThresholdBtn = ({ disable, onClick }: AddThresholdBtnProps) => {
 const { t } = useTranslation();
  const handleOnClick = () => {
    if (!disable && onClick) {
      onClick();
    }
  };

  return (
    <div
      onClick={handleOnClick}
      className={`gx-add-threshold pb-3 ${!disable ? "gx-cursor-pointer" : ""}`}
    >
      <img
        src={
          disable
            ? `${ICON_BASE_PATH}plus-dim-icon.svg`
            : `${ICON_BASE_PATH}plus-icon-b.svg`
        }
        alt="Add icon"
        className="gx-add-threshold-icon "
      />
      <div
        className={`gx-add-threshold-label gx-font-regular ${
          disable ? "gx-disabled-text" : "gx-enabled-text"
        }`}
      >
          {t("add_threshold")}
      </div>
    </div>
  );
};
